import React, { useState, useEffect } from "react";
import { List } from "antd";
import DepartmentListItem from "./DepartmentListItem";

const AssignDepartmentList = ({
  departments = [],
  onDepartmentSelect,
  initialSelectedDepartmentId = null,
}) => {
  const [selectedDepartmentId, setSelectedDepartmentId] = useState(initialSelectedDepartmentId);

  // Update selectedDepartmentId when initialSelectedDepartmentId changes
  useEffect(() => {
    setSelectedDepartmentId(initialSelectedDepartmentId);
  }, [initialSelectedDepartmentId]);

  const handleDepartmentSelect = departmentId => {
    setSelectedDepartmentId(departmentId);
    const selectedDepartment = departments.find(dept => dept.id === departmentId);
    if (onDepartmentSelect) {
      onDepartmentSelect(selectedDepartment);
    }
  };

  return (
    <div>
      <List
        dataSource={departments}
        renderItem={department => (
          <List.Item className="!p-0 !border-0 !w-full">
            <div className="w-full">
              <DepartmentListItem
                department={department}
                selected={selectedDepartmentId === department.id}
                onSelect={handleDepartmentSelect}
              />
            </div>
          </List.Item>
        )}
      />
    </div>
  );
};

export default AssignDepartmentList;
